// Dish Tech React
import {getStore} from '@dishtech-react/redux';

const [store, history] = getStore({}, {}, []);

export {history};
export default store;
